export default __webpack_public_path__ + "static/media/save-icon.160b0039.svg";